export default __webpack_public_path__ + "static/media/default_car.9d1cd555.jpeg";